import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import { get, merge, join, reduce, find } from 'lodash';
import prettyPhone from '../../../../../lib/prettyPhone';
import CloseX from '../../../../../common/svgs/CloseX';
import StatusDropDown from '../../../../../common/components/StatusDropDown';

import {lookup, getLookupValue} from '../../../../../redux/helpers/staticData';
import * as companyApi from '../../../../../redux/actionCreators/async/companies';
import * as companyStore from '../../../../../redux/actionCreators/sync/companies';

@connect((store) => {
  return {
		staticData: store.staticData,
		labels: get(store, 'labels.CompanyCard', {}),
  };
})
export default class CompanyCard extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		staticData: PropTypes.object,
		company: PropTypes.object.isRequired,
		onClose: PropTypes.func.isRequired
	}
	constructor(props, context) {
		super(props, context);
	}
	goToCompanyWorksheet() {
		this.props.dispatch(push(`/admin/companies/${this.props.company.id}/details`));
	}
	back() {
		this.props.dispatch(push('/admin/companies/'));
		this.props.onClose();
	}

	handleStatusChange = (companyId) => (event, value) => {
    if (value) {
      this.props.dispatch(companyApi.updateCompanyStatus(companyId, value, (err, result) => {
        if (err || !result) {
          return console.error(err || 'Update failed.');
        }

				result.company = merge(this.props.company, result.company);

				this.props.dispatch(companyStore.updateCompany(result));
      }));
    }
  }

  showSelectedValues(type, ids) {
    const selectedValues = reduce(this.props.staticData[type], (values, dataObj) => {
      if (!values) {
        values = [];
      }

      if (find(ids, (item) => dataObj.id === item || dataObj.value === item)) {
        values.push(dataObj.name || dataObj.primaryText);
      }
      return values;
    }, []);


    return join(selectedValues, ', ');
  }


	render() {
		function getAddress(user, staticData) {
			const addressArr = [];
			if (user.address) addressArr.push(user.address);
			if (user.city) addressArr.push(user.city);
      if (user.state) addressArr.push(lookup(staticData, 'stateList', {id: user.state}));
			if (user.zip) addressArr.push(user.zip);
			return addressArr.join(', ');
		}

    const sanitize = (val) => val || 'N/A';
		const company = get(this.props, 'company', {});
		const currentStatus = getLookupValue(this.props.staticData, 'companyStatus', {id: get(company, 'companyStatus', 0)});
		const timezone = lookup(this.props.staticData, 'timezoneList', {id: company.timezone});
		const relationshipManager = getLookupValue(this.props.staticData, 'relationshipManagers', { id: company.relationshipManagerId });

		return (
			<div className="company-card-preview">
				<div className="close wv-pointer" onClick={this.back.bind(this)}>
					CLOSE <CloseX style={{color: '#fff'}}/>
				</div>
				<div className="name-container">
					<div className='company-card-header'>
						<div className="full-name" data-id="Full Name">{company.name}</div>
						<StatusDropDown
							status={currentStatus}
							smallDisplay={true}
							menuItems={this.props.staticData.companyStatus}
							onChange={this.handleStatusChange(company.id)}
						/>
					</div>
					<div className='company-card-content'>
						<div className="relatios-block">
							<div>Relationship Manager:  { get(relationshipManager, 'firstName') } { get(relationshipManager, 'lastName') }</div>
							<div>{this.props.labels.industry}:  {this.showSelectedValues('industryTypesList', get(company, 'industryTypes'))}</div>
							<div>{getAddress(company, this.props.staticData)} </div>
						</div>
						<div className="information-block">
							<div>Entered: {company.dateCreated ? moment(company.dateCreated).format('L') : sanitize(company.dateCreated)}</div>
							<div>Updated: {company.dateModified ? moment(company.dateModified).format('L') : sanitize(company.dateModified)}</div>
							<div>Time Zone: {timezone}</div>
							<div>Main Number: {prettyPhone(company.phoneNumber)}</div>
						</div>
					</div>

				</div>
					<div className="navigate-to wv-pointer" data-id="View Worksheet">
						<span onClick={this.goToCompanyWorksheet.bind(this)}>view Worksheet</span>
					</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Dashboard/Card/index.js